<template>
  <div class="w-full my-4 flex gap-x-4 snap-mandatory snap-x overflow-x-scroll p-4 bg-primary-50">
    <div class="snap-start shrink-0" />
    <item-file v-for="file in files" :key="file.id" :file="file" class="snap-start shrink-0">
      <button class="shrink-0 text-primary-200 hover:text-primary-400 px-2" @click="onDelete(file)">
        <TrashCanOutline class="h-6 w-6" aria-hidden="true" />
      </button>
    </item-file>
  </div>
</template>

<script setup>
import ItemFile from './ItemFile.vue';
import TrashCanOutline from 'vue-material-design-icons/TrashCanOutline.vue';
import { Modal } from '../composables/useModal';

const props = defineProps({
  files: {
    type: Array,
    default: () => []
  },
  noConfirm: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits([ 'delete' ]);

async function onDelete(file) {
  if (props.noConfirm) {
    emit('delete', file.id);
    return;
  }

  const confirm = await Modal.confirm({
    title: 'Delete file',
    body: `Are you sure you want to delete file ${file.name}?`,
    okButton: 'Delete',
    cancelButton: 'Cancel'
  });

  if (!confirm) {
    return;
  }
  emit('delete', file.id);
}
</script>
